import { render, staticRenderFns } from "./SelfPublishingFlowNav.vue?vue&type=template&id=b5d1c950&scoped=true&"
import script from "./SelfPublishingFlowNav.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingFlowNav.vue?vue&type=script&lang=js&"
import style0 from "./SelfPublishingFlowNav.vue?vue&type=style&index=0&id=b5d1c950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d1c950",
  null
  
)

export default component.exports